import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateEventExpenseService, type UpdateEventExpensePayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useUpdateEventExpense = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ expenseId, payload }: { expenseId: number; payload: UpdateEventExpensePayload }) =>
      updateEventExpenseService(agendaId, eventId, expenseId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
    },
  })
}
